import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { SoftKeyboardProvider } from './contexts/SoftKeyboardContext';

declare const __BUILD_STAMP__: string;
if (typeof __BUILD_STAMP__ !== 'undefined') {
  (window as Window & { __KP_BUILD__?: string }).__KP_BUILD__ = __BUILD_STAMP__;
}

// Suppress browser extension errors that are harmless
window.addEventListener('error', (event) => {
  // Filter out common browser extension errors
  const errorMessage = event.message || '';
  const errorSource = event.filename || '';
  
  // Ignore errors from browser extensions (BG.js, extension scripts, etc.)
  if (
    errorSource.includes('BG.js') ||
    errorSource.includes('extension://') ||
    errorSource.includes('chrome-extension://') ||
    errorSource.includes('moz-extension://') ||
    errorMessage.includes('Could not establish connection') ||
    errorMessage.includes('Receiving end does not exist') ||
    errorMessage.includes('message channel closed')
  ) {
    event.preventDefault();
    return false;
  }
});

// Suppress unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || '';
  const errorString = String(event.reason || '');
  
  // Ignore errors from browser extensions
  if (
    errorMessage.includes('Could not establish connection') ||
    errorMessage.includes('Receiving end does not exist') ||
    errorMessage.includes('message channel closed') ||
    errorString.includes('BG.js') ||
    errorString.includes('extension://')
  ) {
    event.preventDefault();
    return false;
  }
});

// Suppress dataset errors from third-party libraries (often harmless timing issues)
window.addEventListener('error', (event) => {
  const errorMessage = event.message || '';
  const errorSource = event.filename || '';
  
  // Suppress dataset errors that are often from third-party libraries
  if (
    errorMessage.includes("Cannot read properties of null (reading 'dataset')") ||
    errorMessage.includes("Cannot read property 'dataset' of null") ||
    (errorSource.includes('.js') && errorMessage.includes('dataset'))
  ) {
    // These are often harmless timing issues with DOM access
    event.preventDefault();
    return false;
  }
}, true); // Use capture phase to catch errors early

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <SoftKeyboardProvider>
      <App />
    </SoftKeyboardProvider>
  </React.StrictMode>
);
